module.exports = __webpack_public_path__ + "img/icon_bg.1c3e16bb.png";